import React, {useEffect} from 'react'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { primaryColor } from '../../assets/jss/material-dashboard-react';
import { IntlShape, useIntl } from 'react-intl';
import { CreateUrl, CallGetAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';

interface Props {
    handleClose: () => void
    item: ItemDisplayData
    reloadData: () => void
}

interface ItemDisplayData {
    src: string
    caption: string
    id: string
    azure: boolean
    fileName: string | null
    type: string
}
const ImageOverlayMobile:React.FC<Props> = ({ handleClose, item, reloadData }) => {
    

    const intl:IntlShape = useIntl()

    const confirmDelete = (data: ItemDisplayData): void => {
        if (window.confirm(intl.formatMessage({ id: "Are you sure you want to delete this item?" }))) {
            removeImage(data);
            
        }
    };


    const removeImage = (data: ItemDisplayData): void => {
       
        if (data.azure) {
            //delete from Azure
            CallDeleteAPI(CreateUrl('/api/aquaguard/images?id=' + data.fileName), {})
                .then(async response => {
                    if (response.status == 200) {
                        handleClose()
                        reloadData()
                        //img.Me.createSuccessNotification();
                        //this.reloadData();
                    }
                    else {
                        //img.Me.createErrorNotification();
                    }
                })
                .catch(function (error) {
                    //img.Me.createErrorNotification();
                    console.error(error);
                    handleClose()
                });
        } else {
            //delete from database
            CallDeleteAPI(CreateUrl('/api/aquaguard/images?id=' + data.id), {})
                .then(async response => {
                    if (response.status == 200) {
                        handleClose()
                        reloadData()
                        //img.Me.createSuccessNotification();
                        //this.reloadData();
                    }
                    else {
                        //img.Me.createErrorNotification();
                    }
                })
                .catch(function (error) {
                    handleClose()
                    //img.Me.createErrorNotification();
                    console.error(error);
                });
        }

    }

    const handleDownload = (data: ItemDisplayData): void => {
        console.log(data)
        fetch(data.src)
            .then(response => response.blob())
            .then(blob => {
                const file = new Blob([blob], { type: data.type });
                const element = document.createElement("a");
                element.href = URL.createObjectURL(file);
                element.download = data.fileName ? data.fileName : 'Image File';
                document.body.appendChild(element);
                element.click();
            })
            .catch(error => console.error('Error fetching the image:', error));

    };

    return (
        <div
            style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                background: '#000000dd',
                zIndex: 10000000,
                top: 0,
                left: 0
            }}
        >
            <div style={{ transform: `translateY(${window.scrollY - 500}px)` }}>
                <div style={{ margin: '20px' }}>
                    {item.type === 'image / jpeg' ?
                        <img
                        src={item.src}
                        width='100%'
                        style={{
                            borderTopLeftRadius: 5,
                            borderTopRightRadius: 5
                        }}
                        />
                        :
                        <iframe
                            style={{
                                border: "none",
                                marginTop: "2px",
                                width: "100%",
                                borderTopLeftRadius: 5,
                                borderTopRightRadius: 5
                            }}
                            src={`${item.src}#toolbar=0&navpanes=0&scrollbar=0`}

                        />}
                    {item.caption && <div
                        style={{
                            background: primaryColor[0],
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: 10,
                            borderBottomLeftRadius: 5,
                            borderBottomRightRadius: 5
                        }}>
                        <p style={{ color: 'white' }}>{item.caption}</p>
                    </div>}
                    <div style={{marginTop: 20} }>
                        <FullWidthMobileButton text='Download' onClick={(): void => handleDownload(item)} color='secondary' disabled={false} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <FullWidthMobileButton text='Delete' onClick={(): void => confirmDelete(item)} color='warning' disabled={false} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <FullWidthMobileButton text='Close' onClick={(): void => handleClose()} color='error' disabled={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ImageOverlayMobile